import HasPermission from "../../app/PermissionChecker"

function HomeWidgetLayout({
    title = "Wdiget Title",
    isLoading = false,
    isSystemWidget = false,
    permission = null,
    onPageRefresh = null,
    content = <>Widget Content"</>,
}) {

    if (permission == null || (permission != null && HasPermission(permission))) {
        return (
            <div className="d-flex flex-column">
                <div className={`card text-white bg-dark h-100  ${isSystemWidget && "bg-opacity-25"}`}>
                    <div className="card-header text-muted">{title}</div>
                    <div className={`card-body d-flex flex-column justify-content-between text-center ${isLoading ? "opacity-25" : ""}`}>
                        {content}
                    </div>
                </div>
            </div >

        )
    }
}

export default HomeWidgetLayout